type PublicStateCopy = {
  error: { title: string; retry: string };
  loading: { title: string; description: string };
  notFound: {
    metadataTitle: string;
    title: string;
    description: string;
    home: string;
    help: string;
    popular: string;
    pricing: string;
    support: string;
    docs: string;
    tools: string;
  };
};

const pt: PublicStateCopy = {
  error: {
    title: "Não foi possível carregar esta página",
    retry: "Tentar novamente",
  },
  loading: {
    title: "Carregando",
    description: "Preparando o conteúdo para você.",
  },
  notFound: {
    metadataTitle: "Página não encontrada | SendBot",
    title: "Página não encontrada",
    description:
      "O endereço pode ter mudado ou a página não está mais disponível.",
    home: "Voltar ao início",
    help: "Obter ajuda",
    popular: "Atalhos úteis",
    pricing: "Ver planos",
    support: "Falar com suporte",
    docs: "Documentação",
    tools: "Ferramentas",
  },
};

const en: PublicStateCopy = {
  error: { title: "We couldn't load this page", retry: "Try again" },
  loading: { title: "Loading", description: "Preparing the content for you." },
  notFound: {
    metadataTitle: "Page not found | SendBot",
    title: "Page not found",
    description:
      "The address may have changed or this page is no longer available.",
    home: "Back to home",
    help: "Get help",
    popular: "Useful links",
    pricing: "View pricing",
    support: "Contact support",
    docs: "Documentation",
    tools: "Tools",
  },
};

const es: PublicStateCopy = {
  error: { title: "No pudimos cargar esta página", retry: "Intentar de nuevo" },
  loading: {
    title: "Cargando",
    description: "Preparando el contenido para ti.",
  },
  notFound: {
    metadataTitle: "Página no encontrada | SendBot",
    title: "Página no encontrada",
    description:
      "La dirección puede haber cambiado o la página ya no está disponible.",
    home: "Volver al inicio",
    help: "Obtener ayuda",
    popular: "Enlaces útiles",
    pricing: "Ver planes",
    support: "Contactar soporte",
    docs: "Documentación",
    tools: "Herramientas",
  },
};

const fr: PublicStateCopy = {
  error: { title: "Impossible de charger cette page", retry: "Réessayer" },
  loading: { title: "Chargement", description: "Préparation du contenu." },
  notFound: {
    metadataTitle: "Page introuvable | SendBot",
    title: "Page introuvable",
    description:
      "L'adresse a peut-être changé ou cette page n'est plus disponible.",
    home: "Retour à l'accueil",
    help: "Obtenir de l'aide",
    popular: "Liens utiles",
    pricing: "Voir les tarifs",
    support: "Contacter le support",
    docs: "Documentation",
    tools: "Outils",
  },
};

const it: PublicStateCopy = {
  error: { title: "Impossibile caricare questa pagina", retry: "Riprova" },
  loading: {
    title: "Caricamento",
    description: "Stiamo preparando i contenuti.",
  },
  notFound: {
    metadataTitle: "Pagina non trovata | SendBot",
    title: "Pagina non trovata",
    description:
      "L'indirizzo potrebbe essere cambiato o la pagina non è più disponibile.",
    home: "Torna alla home",
    help: "Ottieni aiuto",
    popular: "Link utili",
    pricing: "Vedi i piani",
    support: "Contatta il supporto",
    docs: "Documentazione",
    tools: "Strumenti",
  },
};

const de: PublicStateCopy = {
  error: {
    title: "Diese Seite konnte nicht geladen werden",
    retry: "Erneut versuchen",
  },
  loading: {
    title: "Wird geladen",
    description: "Inhalte werden vorbereitet.",
  },
  notFound: {
    metadataTitle: "Seite nicht gefunden | SendBot",
    title: "Seite nicht gefunden",
    description:
      "Die Adresse wurde möglicherweise geändert oder die Seite ist nicht mehr verfügbar.",
    home: "Zur Startseite",
    help: "Hilfe erhalten",
    popular: "Nützliche Links",
    pricing: "Preise ansehen",
    support: "Support kontaktieren",
    docs: "Dokumentation",
    tools: "Tools",
  },
};

const ro: PublicStateCopy = {
  error: { title: "Pagina nu a putut fi încărcată", retry: "Încearcă din nou" },
  loading: {
    title: "Se încarcă",
    description: "Pregătim conținutul pentru tine.",
  },
  notFound: {
    metadataTitle: "Pagina nu a fost găsită | SendBot",
    title: "Pagina nu a fost găsită",
    description:
      "Adresa poate fi schimbată sau pagina nu mai este disponibilă.",
    home: "Înapoi la pagina principală",
    help: "Obține ajutor",
    popular: "Linkuri utile",
    pricing: "Vezi planurile",
    support: "Contactează suportul",
    docs: "Documentație",
    tools: "Instrumente",
  },
};

const copies: Record<string, PublicStateCopy> = { pt, en, es, fr, it, de, ro };

export const getPublicStateCopy = (locale: string): PublicStateCopy =>
  copies[locale] ?? copies[locale.split("-")[0]] ?? en;
